// extracted by mini-css-extract-plugin
export default {"form":"ExaminationForm_form__pvSaC","selectDivider":"ExaminationForm_selectDivider__VgoVF","selectButton":"ExaminationForm_selectButton__iyPKP"};